<template>
  <button v-if="isAdmin && status != 'FINISH'" class="btn btn-small" @click.prevent="$emit('deleteItem')">
    &times;
  </button>
</template>

<script>
import logger from '@/logger';

export default {
  name: 'ActionsView',
  props: {
    status: {
      type: String,
      required: true,
    },
    isAdmin: {
      type: Boolean,
    },
    deleteItem: {
      type: Function,
      default: s => {
        logger.debug('deleteItem:', s);
      },
    },
  },
};
</script>
